<template>
  <v-select
    label="Property Type"
    v-bind="$attrs"    
    :items="structure_types"
    item-text="text"
    item-value="value"
    :value="value"
    @input="(newVal) => $emit('input', newVal)"
  ></v-select>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: "PropertyTypeSelect",

  props: ['value'],

  computed: {
    ...mapGetters('auth', ['settings']),

    structure_types() {
      if (!this.settings.structure_types) {
        return []
      }

      const entries = Object.entries(this.settings.structure_types)
      return entries.map( ([k,v]) => ({ text: v, value: k}) )
    },
  },

  methods: {
    ...mapActions('auth', ['loadSettings']),
  },

  created() {
    this.loadSettings()
  },
}

</script>